import { CartItem } from '~/types';

export default function getSameItemCount(items: Array<CartItem>, targetId: string): number {
  return items.reduce((acc: number, { count, id }) => {
    return id === targetId ? acc + count : acc;
  }, 0);
}
